var feed = new Instafeed({
  get: 'user',
  userId: 1654022969,
  limit: 20,
  accessToken: '1654022969.467ede5.c8350b20a82949b197c0a0aee1eeb25d',
  resolution: 'low_resolution',
  template: '<li><a href="{{link}}" rel="ig" title="{{caption}}" target="_blank"><img src="{{image}}" /></a></li>',
  after : function() {
    $('.flexslider').flexslider({
      animation: "fade",
      controlNav: false,
      directionNav: false 
  	});
  }
  
});
feed.run();
  